import { vuexHandbook } from '@/store/composition/handbook'
import { CoatingApi } from '@/api/handbook/position/Coating/CoatingApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: CoatingApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
